import { render } from "./NewsCell.vue?vue&type=template&id=5c7d3e82&scoped=true"
import script from "./NewsCell.vue?vue&type=script&lang=js"
export * from "./NewsCell.vue?vue&type=script&lang=js"

import "./NewsCell.vue?vue&type=style&index=0&id=5c7d3e82&lang=scss&scoped=true"

import exportComponent from "/opt/homebrew/var/www/zsplus_channel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c7d3e82"]])

export default __exports__